import { useLabOS } from '@/lib/labos';

export interface UserRoles {
  roles: string[];
  loading: boolean;
  error: string | null;
}

/**
 * Custom hook to get user roles from LabOS context
 * Roles are fetched during authentication in LabOSAuth component
 */
export function useRoles(): UserRoles {
  const { user, loading } = useLabOS();

  return {
    roles: user?.roles || [],
    loading,
    error: null,
  };
}

/**
 * Helper function to check if user has a specific role
 */
export function hasRole(roles: string[], role: string): boolean {
  return roles.includes(role);
}
